/**
 * МАРКЕР ДОКУПКИ РАЗМЕРА на квартале города (этап найма, выбран отряд на казарме):
 * темный шестигранный медальон с золотой оправой в золотом ореоле — в одной
 * гамме с анимацией улучшения отряда. Сверху «+N» с человечками, снизу цена.
 *
 * Рисует scenes/unitSizeRecruitmentMarker, текстуры считает код
 * (utils/effects/sizeRecruitmentTextures). Размеры — доли размера ячейки.
 */

export const SIZE_RECRUITMENT_TEXTURE_KEYS = {
  // Медальон — в своих цветах, не красится
  PLATE: 'size_recruitment_plate',
  // Тот же медальон в серебре: плашки дохода очками (configs/incomeMarker)
  PLATE_SILVER: 'size_recruitment_plate_silver',
  // Шестигранный ореол под медальоном (белый, красится tint)
  HALO: 'size_recruitment_halo',
  // Человечки, как на иконке размера отряда, но белые: красятся tint
  PEOPLE: 'size_recruitment_people',
};

export const SIZE_RECRUITMENT_MARKER = {
  // Ширина картинки медальона с запасом под тень
  plateSizeFactor: 1.72,
  // Подсвеченный ореол выходит за медальон и заливает ячейку
  halo: {
    sizeFactor: 2.5,
    tint: 0xffb81f,
    minAlpha: 0.5,
    maxAlpha: 1,
    minScale: 0.94,
    maxScale: 1.06,
    pulseMs: 950,
  },
  // Строки считаются от центра медальона
  sizeRow: {
    y: -0.2,
    textX: -0.3,
    textScale: 0.5,
    iconX: 0.24,
    iconSizeFactor: 0.44,
    iconTint: 0xffe08a,
    // Золотой перелив цифр сверху вниз
    textTintTop: 0xfff3c0,
    textTintBottom: 0xffb81f,
  },
  priceRow: {
    y: 0.28,
    textX: -0.17,
    textScale: 0.42,
    iconX: 0.2,
    iconScale: 0.044,
  },
  // Размер уже максимальный: маркер кликабелен (тост с причиной), но потух
  disabled: {alpha: 0.75, plateTint: 0x8a8a8a, contentTint: 0xb5b5b5},
};
